/* AlgemeneVoorwaardenPage - Displays the algemene-voorwaarden PDF in an iframe
 * Updated: Initial creation - embeds /assets/legal/algemene-voorwaarden.pdf
 * Updated: Unified layout to match BlogsPage - bg-white, max-w-7xl, jv-primary headings */

import { Helmet } from 'react-helmet-async';
import { FileText, Download } from 'lucide-react';
import ContactBar from '@/components/ContactBar';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageBreadcrumb from '@/components/PageBreadcrumb';

export default function AlgemeneVoorwaardenPage() {
  const pdfUrl = '/assets/legal/algemene-voorwaarden.pdf';

  return (
    <>
      <Helmet>
        <title>Algemene voorwaarden | Buitn Planten</title>
        <meta name="description" content="Lees de algemene voorwaarden van Buitn Planten. Onze leverings- en betalingsvoorwaarden voor jouw bestelling." />
        <link rel="canonical" href="https://buitnplanten.nl/algemene-voorwaarden" />
      </Helmet>

      <ContactBar />
      <Header />

      <main className="pt-8 pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-8 sm:px-12 lg:px-16">
          <PageBreadcrumb items={[{ label: 'Home', href: '/' }, { label: 'Algemene voorwaarden' }]} />
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-jv-primary mb-6">
              Algemene voorwaarden
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Hier vind je onze algemene voorwaarden. Hierin lees je onze leverings- en betalingsvoorwaarden.
            </p>
          </div>

          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100">
            <div className="flex items-center justify-between px-6 py-4 bg-jv-primary/5 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <FileText className="h-5 w-5 text-jv-primary" />
                <span className="font-semibold text-jv-dark">algemene-voorwaarden.pdf</span>
              </div>
              <a
                href={pdfUrl}
                download="algemene-voorwaarden.pdf"
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-jv-primary bg-white border border-jv-primary/30 rounded-lg hover:bg-jv-primary hover:text-white transition-colors"
              >
                <Download className="h-4 w-4" />
                Download
              </a>
            </div>

            <div className="w-full" style={{ height: '80vh', minHeight: '600px' }}>
              <iframe
                src={pdfUrl}
                title="Algemene voorwaarden Buitn Planten"
                className="w-full h-full border-0"
              />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
